var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 64,
    viewBox: "0 0 136 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136 3.42847L86 3.42847L90.5455 54.689L110.793 60.5713L131.868 54.689L136 3.42847Z",
    fill: "#DAB92C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.764 58.9897V9.83008L132.425 10.2502L128.293 54.3679L111.764 58.9897Z",
    fill: "#FFD93A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.111 16.5525H103.913L104.739 44.2836L103.086 43.8634L102.673 38.8214H97.7145L98.1278 48.9054L110.111 51.8466V16.5525Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.053 16.5525H112.591L112.45 35.4601H118.789L118.7 43.5387L112.45 45.5441V52.8202L124.574 48.9054L125.814 29.1575L118.789 28.7374L118.7 22.1196H126.64L127.053 16.5525Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4L7.9625 54.4L28 60L48.0305 54.4035L52.5 4L3.5 4Z",
    fill: "#2196F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9592 20.4815L42.3957 26.813L40.6947 45.7935L28.0002 49.304L27.9897 49.3075L15.3022 45.7935L14.4167 35.8675H20.6327L21.0947 41.016L27.9932 42.878L27.9967 42.8745L34.9057 41.0125L35.8472 32.434L14.1192 32.4935L13.5032 26.6275L36.3687 26.358L36.8307 20.079L12.8907 20.1455L12.4882 14.304H28.0002H43.5122L42.9592 20.4815Z",
    fill: "#FAFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1086 0L48.2049 57.6875L69.6747 64L90.8409 57.6875L95.9373 0H43.1086Z",
    fill: "#FD982C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6747 0V64L90.8409 57.6875L95.9373 0H69.6747Z",
    fill: "#FA502E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3816 19.9224L62.832 19.9219L63.2093 24.4004H85.2746L83.4914 49.4243L69.6558 53.7935L54.8056 48.7788V38.6309H64.0306V41.6533L69.6576 43.541L74.9892 41.6519L75.3773 34.1592H54.9487L52.6424 10.2886H85.3816V19.9224Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6747 10.2886H85.3816V19.9224H69.6747V10.2886Z",
    fill: "#DEECF1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3773 34.1592L74.9892 41.6519L69.6747 43.5352V53.7876L83.4914 49.4243L85.2746 24.4004H69.6747V34.1592H75.3773Z",
    fill: "#DEECF1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg16);
export default __webpack_public_path__ + "static/media/img16.d9dcb6d1dea3422dc59b762b6e4fa4fb.svg";
export { ForwardRef as ReactComponent };